import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './styles/index.css';
import { AppAuthProvider } from './contexts/auth/AppAuthContext';
import reportWebVitals from './reportWebVitals';
import { HomePage } from './pages/HomePage';
import { SignInPage } from './pages/SignInPage';
import { TutorsList } from './pages/UserPages/TutorsList';
import { Error404 } from './pages/404Error';
import { Account } from './pages/Authorised/Account';
import { SetupAccount } from './pages/SetupAccount';
import { ContactUs } from './pages/ContactUs';
import { SignUpPage } from './pages/SignUpPage';
import { BookSession } from './pages/UserPages/BookSession';
import { AdminRequests } from './pages/Admin/AdminRequests';
import { ViewAdminRequest } from './pages/Admin/ViewAdminRequest';
import { UtilityProvider } from './contexts/auth/UtilityContext';
import { UserCalendar } from './pages/Authorised/UserCalendar';
import { Schools } from './pages/Admin/Schools';
import { AdminFunctions } from './pages/Admin/AdminFunctions';
import { Messages } from './pages/Authorised/Messages';
import { TutorSignUpPage } from './pages/TutorSignUpPage';
import { UserAgreement } from './pages/UserAgreement';
import { VerifyEmail } from './pages/VerifyEmail';
import { AboutUs } from './pages/AboutUs';
import { Pricing } from './pages/Pricing';
import { AdminTutorsView } from './pages/Admin/AdminTutorsView';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { UpcomingTutorPayments } from './pages/Admin/UpcomingTutorPayments';
import { UpcomingTutorSessions } from './pages/Admin/UpcomingTutorSessions';

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/login",
    element: <SignInPage />,
  },
  {
    path: "/signup",
    element: <SignUpPage />,
  },
  {
    path: "/tutor-signup",
    element: <TutorSignUpPage />,
  },
  {
    path: "/user-calendar",
    element: <UserCalendar />,
  },
  {
    path: "/tutors",
    element: <TutorsList />,
  },
  {
    path: "/book-session",
    element: <BookSession />,
  },
  {
    path: "/admin-requests",
    element: <AdminRequests />,
  },
  {
    path: "/admin-pending-tutor-payments",
    element: <UpcomingTutorPayments />,
  },
  {
    path: "/admin-upcoming-tutor-sessions",
    element: <UpcomingTutorSessions />,
  },
  {
    path: "/admin-schools",
    element: <Schools />,
  },
  {
    path: "/view_admin_request",
    element: <ViewAdminRequest />,
  },
  {
    path: "/admin-functions",
    element: <AdminFunctions />,
  },
  {
    path: "/admin-tutors",
    element: <AdminTutorsView />,
  },
  {
    path: "/messages",
    element: <Messages />,
  },
  {
    path: "/account",
    element: <Account />,
  },
  {
    path: "/userAgreement",
    element: <UserAgreement />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "/about",
    element: <AboutUs />,
  },
  {
    path: "pricing",
    element: <Pricing />,
  },
  {
    path: "/setup-account",
    element: <SetupAccount />,
  },
  {
    path: "/verify-email",
    element: <VerifyEmail />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "*",
    element: <Error404 />,
  }
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppAuthProvider>
      <UtilityProvider>
        <RouterProvider router={router} />
      </UtilityProvider>
    </AppAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
